module.exports = __webpack_public_path__ + "static/media/03_after.36a222a6.png";